import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default function SecureRoute({ component: Component, ...restProps }) {
    const {exact, history, location, match, path, ...otherProps } = restProps
    return (
        
        <Route
            {...restProps}
            render={(props) =>
                restProps.isAuthenticated ?
                    <Component {...props} {...otherProps} />
                    :
                    <Redirect
                        to={{
                            pathname: "/",
                            state: { from: props.location }
                        }}
                    />
            }
        />
    );
}